import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Dialog from '@mui/material/Dialog';
import Slider from '@mui/material/Slider';
import Button from '@mui/material/Button';
import UploadEditor from 'react-avatar-editor';
import Upload from 'react-avatar';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import constants from './../../shared/constants';
import { getAuthApp } from '../../services/security/authApp';
import { decrypt } from '../../services/security/encryptorHandlerSecurity';
import Validators from './../../components/renderFields/validatorsFields';
import UserHelper from '../../helpers/UserHelper';
import { TextField, useInput } from 'react-admin';
import { Field } from 'redux-form';

const QUERY = '/attachments/cover/upload';

const styles = {
  dropzone: {
    width: 'calc(100% - 40px)',
    height: 'calc(100% - 40px)',
    cursor: 'pointer',
    backgroundColor: 'lightgray',
    padding: 20,
  },
};

class UploadInput extends Component {
  constructor(props) {
    console.log('31 - constructor', props)
    super(props);
    this.state = {
      dialogOpen: false,
      urlEditor: null,
      isDefault: true,
      file: null
    };
  }

  setEditorRef = editor => {
    this.editor = editor;
  };

  handleSaveImage = async () => {
    console.log('45 - handleSaveImage', this.props);
    const { onChange } = this.props;
    const { updateRequired } = this.props;
    const v = await UserHelper.validateLocal();
    const user = typeof v === 'string' && v !== null ? JSON.parse(decrypt(localStorage.getItem(v))) : null;
    const url = `${constants.general.serverURL}/api/attachments/cover/download/` + this.state.file.name;
    const image = new FormData();
    image.append('file', this.state.file);
    image.append('name', this.state.file.name);


    await fetch(`${constants.general.serverURL}/api${QUERY}?access_token=${user.id}`, {      
      method: 'POST',
      body: image,
      headers: {
        'Authorization': getAuthApp()
      }
    })
      .then(response => {
        console.log("66- Respuesta", response);
        if (response.ok) {
          this.setState({
            dialogOpen: false,
            urlEditor: url
          });
          onChange(url);
          updateRequired(false);
          return response.json();
        }
        throw new Error('Algo salio mal ...');
      })
      .then(data => null)
      .catch(() => this.setState({ dialogOpen: false }));


  };

  handleOnChangeScale = (event, scale) => {
    this.setState({ scale });
  };

  handleCloseDialog = () => {
    this.setState({ dialogOpen: false });
  };

  handleOnDrop = async files => {
    const file = _.first(files);

    try {
      await Validators.fileExtension(file);
      this.setState({
        urlEditor: file.preview,
        isDefault: false,
        file
      });
    } catch (error) {
      console.error(error.message);
      window.alert(error.message);
    }
  };

  handleOpenDialog = () => {
    this.setState({ dialogOpen: true });
  };

  renderDialog = () => {
    const { urlEditor, dialogOpen, scale, isDefault } = this.state;
    return (
      <Dialog
        open={dialogOpen}
        onClose={this.handleCloseDialog}
      >
        <div className="row">
          {!isDefault && (
            <div className="col-xs-7">
              <div className="row">
                <div className="col-xs-1">
                  <Slider
                    style={{ height: 'calc(100% - 30px)', margin: 0 }}
                    orientation="vertical"
                    min={1}
                    max={2}
                    step={0.01}
                    value={scale}
                    onChange={this.handleOnChangeScale}
                  />
                </div>
                <div className="col-xs">
                  <UploadEditor
                    ref={this.setEditorRef}
                    image={urlEditor}
                    width={250}
                    height={250}
                    border={50}
                    color={[0, 0, 0, 0.6]} // RGBA
                    scale={scale}
                    rotate={0}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="col-xs">
            <Dropzone
              multiple={false}
              onDrop={this.handleOnDrop}
              accept="image/*"
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} style={styles.dropzone}>
                  <input {...getInputProps()} />
                  <span>Arrastre o de click para seleccionar la imagen</span>
                </div>
              )}
            </Dropzone>
          </div>
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleCloseDialog}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!this.state.file}
          onClick={this.handleSaveImage}
          autoFocus
        >
          Guardar
        </Button>
      </Dialog>
    );
  };

  render() {
    const { input: { value } = {} } = this.props;
    const displayValue = value || '';

    return (
      <div>
        <a
          role="button"
          tabIndex={0}
          onClick={this.handleOpenDialog}
          onKeyDown={() => { }}
        >
          <Upload src={displayValue} className="image-upload-icon" color="#ff0000" />
        </a>
        {this.renderDialog()}
      </div>
    );
  }
}

UploadInput.propTypes = {
  input: PropTypes.object.isRequired,
};

const inputUploadInput = ({ source, label, isRequired = false, meta: { error }, ...rest }) => {
  const { id, field, fieldState } = useInput({ source });

  return (
    <div className="form-group form-file-container">
      <label style={{
        lineHeight: '22px',
        pointerEvents: 'none',
        userSelect: 'none',
        color: 'rgba(0, 0, 0, 0.3)',
        fontSize: '13px',
        marginBottom: '8px',
        display: 'block'
      }}>
        <TextField
          label={label}
          source={source}
          isRequired={isRequired}
        />
      </label>
      <div className={`position-relative`}>
        <UploadInput id={id} {...field}  />
      </div>
      {error && <FormText className="text-left">{error}</FormText>}
      {
        isRequired && <small className="text-left form-text text-muted alert alert-danger" style={{ color: 'rgb(244, 67, 54)' }}>* Este campo es requerido</small>
      }

    </div>
  );
}

inputUploadInput.propTypes = {
  source: PropTypes.string,
  meta: PropTypes.object
};
inputUploadInput.defaultProps = {
  source: '',
  meta: { error: null }
};

export default inputUploadInput;